import { BackgroundEvents, EventsManager } from "../../../abstracts/events/EventsManager";
import { AbstractModuleController } from "../../../abstracts/modules/AbstractModuleController";
import { Apocalypse } from "../../Apocalypse";
import { ApocalypseBackgroundView } from "./ApocalypseBackgroundView";

export class ApocalypseBackgroundController extends AbstractModuleController {
    protected handleEvents() {
        super.handleEvents();

        EventsManager.on(BackgroundEvents.SHOW_NEXT_BACKGROUND, () => {
            this.view.showNextBackground(Apocalypse.model.data.nextMode);
        });

        EventsManager.trigger(BackgroundEvents.GET_BACKGROUND_VIEW, this.view);
    }

    public get name(): string {
        return `ApocalypseBackgroundController`;
    }

    public get view(): ApocalypseBackgroundView {
        if (this._view === undefined || this._view === null) {
            this._view = new ApocalypseBackgroundView();
        }
        return this._view as ApocalypseBackgroundView;
    }
}
